import { Router } from '@angular/router';
import { SessionService } from 'src/app/session-service.service';
import { Component, OnInit } from '@angular/core';
import { ConfigSettingDto } from 'src/app/model/business/ConfigSettingDto';

@Component({
  selector: 'app-idin-verification-cancelled-page',
  templateUrl: './idin-verification-cancelled-page.component.html',
  styleUrls: ['./idin-verification-cancelled-page.component.css']
})
export class IdinVerificationCancelledPageComponent implements OnInit {

  constructor(private sessionService: SessionService, private router: Router) { }

  ngOnInit(): void {
  }

  get configSettings(): ConfigSettingDto {
    return this.sessionService.getConfigSettingsDto();
  }

  calculationPage(): void {
    this.router.navigate(['calculation', this.sessionService.getIntermediaryId()]);
  }
}
